export const isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
